const badgeColor = '#0a1f2b';

function paintBadge(link) {
    const current = link.style.getPropertyValue('color').replace(/\s/g, '').toLowerCase();
    if (current === badgeColor || current === 'rgb(10,31,43)') {
        return;
    }

    link.style.setProperty('color', badgeColor, 'important');
}

function paint(root) {
    root.querySelectorAll('a[href*="elfsight.com"]').forEach(paintBadge);
}

document.querySelectorAll('.social-media').forEach((root) => {
    paint(root);

    const observer = new MutationObserver(() => paint(root));
    observer.observe(root, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['style'],
    });
});
